import { combineReducers } from 'redux';
import { ERROR_ACTION_BA, ERROR_BA_LIST, ERROR_BA_MASTER_LIST, LOADING_ACTION_BA, LOADING_BA_LIST, LOADING_BA_MASTER_LIST, SUCCESS_ACTION_BA, SUCCESS_BA_LIST, SUCCESS_BA_MASTER_LIST } from './actions';


const loadingBAMasterList = (state = false, action) => {
    switch (action.type) {
        case LOADING_BA_MASTER_LIST:
            return action.loading;
        default:
            return state;
    }
}

const successBAMasterList = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_BA_MASTER_LIST:
            return action.success;
        default:
            return state;
    }
}

const errorBAMasterList = (state = false, action) => {
    switch (action.type) {
        case ERROR_BA_MASTER_LIST:
            return action.error;
        default:
            return state;
    }
}

const BAMasterList = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_BA_MASTER_LIST:
            return action.data;
        default:
            return state;
    }
}

const loadingBeritaAcara = (state = false, action) => {
    switch (action.type) {
        case LOADING_BA_LIST:
            return action.loading;
        default:
            return state;
    }
}

const successBeritaAcara = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_BA_LIST:
            return action.success;
        default:
            return state;
    }
}

const errorBeritaAcara = (state = false, action) => {
    switch (action.type) {
        case ERROR_BA_LIST:
            return action.error;
        default:
            return state;
    }
}

const beritaAcaraList = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_BA_LIST:
            return action.data;
        default:
            return state;
    }
}
const loadingActionBA = (state = false, action) => {
    switch (action.type) {
        case LOADING_ACTION_BA:
            return action.loading;
        default:
            return state;
    }
}

const successActionBA = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_ACTION_BA:
            return action.success;
        default:
            return state;
    }
}

const errorActionBA = (state = false, action) => {
    switch (action.type) {
        case ERROR_ACTION_BA:
            return action.error;
        default:
            return state;
    }
}

const actionBA = (state = [], action) => {
    switch (action.type) {
        case SUCCESS_BA_LIST:
            return action.data;
        default:
            return state;
    }
}

const beritaAcaraReducer = combineReducers({
    loadingBAMasterList,
    successBAMasterList,
    errorBAMasterList,
    BAMasterList,

    loadingBeritaAcara,
    successBeritaAcara,
    errorBeritaAcara,
    beritaAcaraList,

    loadingActionBA,
    successActionBA,
    errorActionBA,
    actionBA

});

export default beritaAcaraReducer;
